import APICaller from '../library/APICaller'

const TeamServices = {
  /**
   * 팀원 매출 목록
   * @param  {String} email 이메일
   * @param  {String} params.companyCode 회사코드
   * @param  {String} params.empEmail 영업사원 이메일
   * @param  {String} params.leader 팀장 구분
   * @param  {String} params.month 청구월
   * @param  {Number} params.pageNo 검색할 페이지 번호
   * @param  {Number} params.size 페이지당 출력 갯수
   * @return {Promise}
   */
  getTeamBillsWithEmail(email, {companyCode, empEmail, leader, month, pageNo, size}) {
    return APICaller.get(`/api/v1/team/bills/${email}`, {
      companyCode, email, empEmail, leader, month, pageNo, size
    })
  },
  /**
   * 팀원 계약 목록
   * @param  {String} email 이메일
   * @param  {String} params.companyCode 회사코드
   * @param  {String} params.empEmail 영업사원 이메일
   * @param  {String} params.leader 팀장 구분
   * @param  {String} params.month 청구월
   * @param  {Number} params.pageNo 검색할 페이지 번호
   * @param  {Number} params.size 페이지당 출력 갯수
   * @return {Promise}
   */
  getTeamContractsWithEmail(email, {companyCode, empEmail, leader, month, pageNo, size}) {
    return APICaller.get(`/api/v1/team/contracts/${email}`, {
      companyCode, email, empEmail, leader, month, pageNo, size
    })
  },
  /**
   * 사용자 권한 등록
   * @param  {String} email 이메일
   * @param  {String} params.auth 사용자 권한
   * @param  {String} params.companyCode 회사코드
   * @param  {String} params.creator 등록자
   * @param  {String} params.leader 조회 권한
   * @param  {Number} params.pageNo 검색할 페이지 번호
   * @param  {Number} params.size 페이지당 출력 갯수
   * @param  {String} params.updater 수정자
   * @return {Promise}
   */
  postTeamDivisionWithEmail(email, {auth, companyCode, creator, leader, pageNo, size, updater}) {
    return APICaller.post(`/api/v1/team/division/${email}`, {
      auth, companyCode, creator, email, leader, pageNo, size, updater
    })
  },
  /**
   * 사용자 권한 수정
   * @param  {String} email 이메일
   * @param  {String} params.auth 사용자 권한
   * @param  {String} params.companyCode 회사코드
   * @param  {String} params.creator 등록자
   * @param  {String} params.leader 조회 권한
   * @param  {Number} params.pageNo 검색할 페이지 번호
   * @param  {Number} params.size 페이지당 출력 갯수
   * @param  {String} params.updater 수정자
   * @return {Promise}
   */
  putTeamDivisionWithEmail(email, {auth, companyCode, creator, leader, pageNo, size, updater}) {
    return APICaller.put(`/api/v1/team/division/${email}`, {
      auth, companyCode, creator, email, leader, pageNo, size, updater
    })
  },
  /**
   * 직원 목록
   * @param  {String} params.companyCode
   * @param  {String} params.email
   * @param  {String} params.leader
   * @param  {Number} params.pageNo
   * @param  {Number} params.size
   * @return {Promise}
   */
  getTeamEmployees({companyCode, email, leader, pageNo, size}) {
    return APICaller.get(`/api/v1/team/employees`, {
      companyCode, email, leader, pageNo, size
    })
  },
  /**
   * 팀원 목록
   * @param  {String} email
   * @param  {String} params.companyCode
   * @param  {String} params.leader
   * @param  {Number} params.pageNo
   * @param  {Number} params.size
   * @return {Promise}
   */
  getTeamMemberWithEmail(email, {companyCode, leader, pageNo, size}) {
    return APICaller.get(`/api/v1/team/member/${email}`, {
      companyCode, leader, pageNo, size
    })
  }
}

export default TeamServices



// WEBPACK FOOTER //
// ./src/services/TeamServices.js